/** Groups an array of objects by a key derived using `getKey`. */
export const groupBy = <T>(
  iter: Iterable<T>,
  getKey: (value: T) => string,
): Record<string, T[]> => {
  const index: Record<string, T[]> = {};
  for (const item of iter) {
    const key = getKey(item);
    if (!index[key]) {
      index[key] = [];
    }
    index[key].push(item);
  }
  return index;
};

/**
 * Groups an array of objects by zero or more keys derived using `getKeys`.
 * The same object can be present in multiple groups.
 */
export const groupByMany = <T>(
  array: T[],
  getKeys: (value: T) => string[],
): Record<string, T[]> => {
  const index: Record<string, T[]> = {};
  for (const item of array) {
    const keys = getKeys(item);
    for (const key of keys) {
      if (!index[key]) {
        index[key] = [];
      }
      index[key].push(item);
    }
  }
  return index;
};
